import { validateToggle, disableSubmitButton, enableSubmitButtons } from './form-validation';

const EDIT_BUTTON = "data-edit-button";
const EDIT_TEXT = "data-edit-text";
const CANCEL_TEXT = "data-cancel-text";
const EDIT_SECTION_SUFFIX = "-data-edit-section";
const ACTIVE_CLASS = "active";
const SAVE_BUTTON_SUFFIX = "-data-edit-save";
const SAVE_BUTTON = "data-edit-save";
const INPUT_ATTRIBUTE = "data-input";
const TYPE_ATTRIBUTE = "data-edit-type";
const VALUE_SUFFIX = "-data-edit-value";
const LABEL_SUFFIX = "-data-edit-label";
const ERROR_PREFIX = "data-edit-error-";
const INVALID_CLASS = "form-element-invalid";
const EDIT_LABEL_PREFIX = "data-edit-label-";

export function dataEdit() {
    var editElements = document.getElementsByClassName(EDIT_BUTTON);
    [].forEach.call(editElements, element => element.addEventListener('click', function (e) { handleEditClick(e) }));

    var saveButtons = document.getElementsByClassName(SAVE_BUTTON);
    [].forEach.call(saveButtons, element => element.addEventListener('click', function (e) { handleSaveClick(e) }));

}

function handleEditClick(e) {
    // Get edit / cancel text from element attributes
    let editLabel = document.getElementById(EDIT_LABEL_PREFIX + e.currentTarget.getAttribute(TYPE_ATTRIBUTE));
    let editSectionDivName = e.currentTarget.getAttribute("name") + EDIT_SECTION_SUFFIX;
    let editSectionDiv = document.getElementById(editSectionDivName);
    // Open
    if (e.currentTarget.innerText === e.currentTarget.getAttribute(EDIT_TEXT)) {
        e.currentTarget.innerText = e.currentTarget.getAttribute(CANCEL_TEXT);
        editLabel.style.display = "inline";
        let input = editSectionDiv.getElementsByTagName('input')[0];
        let labelValue = document.getElementById(e.currentTarget.getAttribute("name") + LABEL_SUFFIX);
        input.value = labelValue.innerText;
        editSectionDiv.classList.add(ACTIVE_CLASS);
        validateToggle(true, input, false);
    }
    // Close
    else {
        e.currentTarget.innerText = e.currentTarget.getAttribute(EDIT_TEXT);
        editLabel.style.display = "none";
        editSectionDiv.classList.remove(ACTIVE_CLASS);
    }
}

function handleDisablingButtonOnEmptyText(el: HTMLInputElement) {
    // Trigger validation if input is null
    if (el.hasAttribute("required") && el.value === "") {
        disableSubmitButton(el as HTMLElement);
        //validateToggle(false, inputToSave);
        return;
    }
    else
        enableSubmitButtons(el as HTMLElement);
}

function handleSaveClick(e) {
    let type = e.currentTarget.getAttribute(TYPE_ATTRIBUTE);

    let inputToSave = document.getElementById(e.currentTarget.getAttribute(INPUT_ATTRIBUTE)) as HTMLInputElement;
    let value = inputToSave.value;

    // Trigger validation if input is null
    if (inputToSave.hasAttribute("required") && value === "") {
        disableSubmitButton(inputToSave);
        //validateToggle(false, inputToSave);
        return;
    }

    let label = document.getElementById(e.currentTarget.getAttribute('name') + LABEL_SUFFIX);
    let error = document.getElementById(ERROR_PREFIX + e.currentTarget.getAttribute('name'));
    saveField(type, value).then(function (json) {
        if ((json as any).success === true) {
            label.innerText = value;
            if (inputToSave.parentElement.classList.contains(INVALID_CLASS)) {
                inputToSave.parentElement.classList.remove(INVALID_CLASS);
            }
            // Close input
            var editElement = document.getElementById(type);
            editElement.click();
        }
        else {
            inputToSave.parentElement.classList.toggle(INVALID_CLASS);
        }

    }, function (reason) {
        // on rejection
        error.classList.toggle(ACTIVE_CLASS);
    });
}

function saveField(type, value) {
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        let url = "/api/v1/dataeditblock/setData/";
        let customerKey = (window as any).customerKey;
        url += "?customerKey=" + customerKey;
        url += "&methodId=" + type;
        url += "&data=" + value;
        xhr.open('POST', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'json';
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send();

        function handler() {
            if (this.readyState === this.DONE) {
                if (this.status === 200) {
                    resolve(this.response);
                } else {
                    reject(new Error('saveField: `' + url + '` failed with status: [' + this.status + ']'));
                }
            }
        };
    });
}

